export default __webpack_public_path__ + "static/media/640_business06-jp-web.0ae6c9da.png";